import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SentBoxListStateType, SentBoxListItemType, Pagination } from 'src/shared/types/src';

const initialState: SentBoxListStateType = {
  loading: true,
  paginatedLoading: false,
  sentMessages: [],
  pagination: {
    currentPage: 1,
    from: 1,
    itemsPerPage: 0,
    lastPage: 1,
    to: 1,
    totalItems: 1,
  },
  deletingMessageIds: []
};

const sentboxSlice = createSlice({
  name: 'sentboxSlice',
  initialState,
  reducers: {
    setSentBoxLoader: (
      state,
      action: PayloadAction<{ loading: boolean }>
    ) => {
      state.loading = action.payload.loading;
    },
    setSentBoxPaginatedLoader: (
      state,
      action: PayloadAction<{ paginatedLoading: boolean }>
    ) => {
      state.paginatedLoading = action.payload.paginatedLoading;
    },
    appendSentBox: (
      state,
      action: PayloadAction<{ list: SentBoxListItemType[]; pagination: Pagination }>
    ) => {
      state.pagination = action.payload.pagination;
      state.sentMessages.push(...action.payload.list);
    },
    resetSentBoxState: () => {
      return {
        ...initialState
      };
    },
    updateDeleteMessageId: (state, action: PayloadAction<{ messageId: string }>) => {
      const messageIds = state.deletingMessageIds;
      const id = action.payload.messageId;
      if (!messageIds.includes(id)) {
        state.deletingMessageIds.push(id);
      } else {
        state.deletingMessageIds = messageIds.filter((x) => x !== id);
      }
    },
    removeSentboxMessage: (state, action: PayloadAction<{ messageId: string }>) => {
      const messages = state.sentMessages;
      state.sentMessages = messages.filter((x: SentBoxListItemType) => String(x.id) !== action.payload.messageId);
    }
  },
});

export const SentBoxActions = sentboxSlice.actions;
export default sentboxSlice.reducer;
